import React, { CSSProperties } from 'react';

import cx from '../../utils/classnames';

import styles from './tagFilter.module.scss';

type Props = {
  /** The value assigned to the tag **/
  value: string;
  /** Flag to define whether it is checked or not **/
  isChecked: boolean;
  /** Function to handle click event for the tag **/
  onClick: () => void;
  style?: CSSProperties;
  customClass?: string;
  testId?: string;
  selectedTagClass?: string;
};

function FilterTag(props: Props) {
  const { value, isChecked, onClick, style, customClass, testId, selectedTagClass } = props;
  return (
    <button
      className={cx(
        styles.tag,
        customClass,
        isChecked ? (selectedTagClass ? selectedTagClass : styles.selected) : styles.default,
      )}
      onClick={onClick}
      style={style}
      data-testid={testId || 'filter-tags'}
    >
      {value}
    </button>
  );
}

FilterTag.defaultProps = {
  value: '',
  isChecked: false,
  onClick: () => {},
};

export default FilterTag;
